import { createReducer, on } from '@ngrx/store';

import {
    LoadCategoryPage,
    LoadCategoryPageSuccess,
    LoadCategorySuccess,
    LoadMenuCategoriesSuccess,
    LoadSeoInfoSuccess,
    ResetCategoryPage,
    SetCategoryPageStyles,
    SetDisplayFilter,
    SetFilterProduct,
    SetLastStateViewed,
    SetOrderProduct,
    SetProductsId,
    SetReorderedFilters,
    LoadNewCollectionPageSuccess,
    SetFilterItemProduct,
    SetFilterIsApplied,
    SetSeoCategoryName,
    LoadLandingPage,
    LoadCategoryPageError,
} from './category-page.actions';
import { CategoryState, InitialCategoryState } from './category-page.state';
import { SetGridTypeSuccess } from './grid-type/grid-type.actions';

import {
    filterGroupArrayNames,
    orderTypes,
    ProductFilterItemArray,
} from '@pages/category';
import { InitialCategory } from '@pages/category/state/category-initial.state';

export const CategoryPageReducer = createReducer(
    InitialCategoryState,

    on(LoadCategoryPage, (state): CategoryState => {
        return {
            ...InitialCategoryState,
            filters: state?.filters || InitialCategoryState.filters,
            gridType: state?.gridType,
        };
    }),

    on(SetLastStateViewed, (state): CategoryState => {
        return {
            ...InitialCategoryState,
            lastCategoryState: state,
        };
    }),

    on(LoadCategoryPageError, (): CategoryState => {
        return {
            ...InitialCategoryState,
            isLoaded: true,
            isError: true,
        };
    }),

    on(LoadCategoryPageSuccess, (state, { categoryProducts, lastState }): CategoryState => {
        const newState = !lastState ? state : lastState;
        // biome-ignore lint/complexity/noExtraBooleanCast: <explanation>
        if (!!lastState) {
            return lastState;
        }
        return {
            ...newState,
            isLoaded: true,
            isError: false,
            productsId: categoryProducts.productIds,
            filters: {
                isApplied: false,
                filters: categoryProducts.filters,
                order: {
                    orderType: orderTypes.RECOMMENDED,
                    isApplied: false,
                },
            },
            gridElements: categoryProducts.gridElements,
            elementDefaultImageTypes: categoryProducts.elementDefaultImageTypes,
            defaultOrders: {
                [orderTypes.RECOMMENDED]: categoryProducts.productIds,
                [orderTypes.NEWEST]: categoryProducts.sortedProductIds,
                [orderTypes.PRICE_ASC]: categoryProducts?.sortedProductIdsByPricesAsc,
                [orderTypes.PRICE_DESC]: categoryProducts?.sortedProductIdsByPricesDesc,
            },
        };
    }),

    on(LoadNewCollectionPageSuccess, (state, payload): CategoryState => {
        return {
            ...state,
            elementDefaultImageTypes: {
                ...state.elementDefaultImageTypes,
                ...payload.elementDefaultImageTypes,
            },
        };
    }),

    on(LoadLandingPage, (state, payload): CategoryState => {
        return {
            ...state,
            landing: payload.landing,
            isError: false,
        };
    }),

    on(LoadCategorySuccess, (state, payload): CategoryState => {
        return {
            ...state,
            category: payload.category,
        };
    }),

    on(SetFilterProduct, (state, payload): CategoryState => {
        // biome-ignore lint/complexity/useSimplifiedLogicExpression: <explanation>
        if (!payload.filters.isApplied && !payload.filters.order.isApplied) {
            return { ...state, filters: { ...payload.filters } };
        }
        return { ...state, filters: payload.filters };
    }),

    on(SetFilterItemProduct, (state, payload): CategoryState => {
        const filters = { ...state.filters.filters };
        filters[payload.filterName] = payload.filterValues;
        return {
            ...state,
            filters: {
                ...state.filters,
                filters,
            },
        };
    }),

    on(SetFilterIsApplied, (state, payload): CategoryState => {
        return {
            ...state,
            filters: {
                ...state.filters,
                isApplied: payload.isApplied,
            },
        };
    }),

    on(SetOrderProduct, (state, payload): CategoryState => {
        return {
            ...state,
            filters: {
                ...state.filters,
                order: {
                    ...state.filters.order,
                    orderType: payload.order,
                    isApplied: payload.order !== orderTypes.RECOMMENDED,
                },
            },
        };
    }),

    on(SetProductsId, (state, { productsId }): CategoryState => {
        return {
            ...state,
            productsId,
        };
    }),

    // #endregion
    on(LoadMenuCategoriesSuccess, (state, { navMenuCategories, filterTypeUsedAsSubcategories }): CategoryState => {
        return {
            ...state,
            navMenuCategories,
            filterTypeUsedAsSubcategories: filterTypeUsedAsSubcategories as filterGroupArrayNames,
        };
    }),

    // ECOMDUTI-13720 TESTAB  TEST A/B - Desarrollo Personalización Contenido - Maqueta de filtros
    on(SetDisplayFilter, (state, payload): CategoryState => {
        return { ...state, displayFilter: payload.displayFilter };
    }),
    // ECOMDUTI-13720 TESTAB  TEST A/B - Desarrollo personalizacion contenido orden de filtros
    on(SetReorderedFilters, (state, payload): CategoryState => {
        const filtersObject: ProductFilterItemArray[] = [];
        for (const filter of payload.filters) {
            filtersObject[filter] = state.filters.filters[filter];
        }
        return { ...state, filters: { ...state.filters, filters: { ...filtersObject } } };
    }),

    on(SetCategoryPageStyles, (state, payload): CategoryState => {
        return { ...state, catalogStyles: payload.catalogStyles };
    }),

    on(LoadSeoInfoSuccess, (state, { seoInfo }): CategoryState => {
        return { ...state, seoInfo };
    }),

    on(SetSeoCategoryName, (state, { seoCategoryName }): CategoryState => {
        return { ...state, seoCategoryName };
    }),

    on(ResetCategoryPage, (state): CategoryState => {
        return {
            ...state,
            category: InitialCategory,
        };
    }),

    on(SetGridTypeSuccess, (state, { gridType }): CategoryState => {
        return {
            ...state,
            gridType,
        };
    }),
);
